import { cx } from '@linaria/core';
import { ButtonHTMLAttributes, useImperativeHandle, useRef } from 'react';
import { animateRipple } from '../common/ripple';
import "./Button.linaria.module.css!=!./Button?./Button.linaria.module.css?css=H4sIAAAAAAAAA41X246jOBB9n6/IajXStDSOMAmBMC/7NL9hGTBQYGzaNreg+fcV4RKgk55+6VbZ51TZpi4nR2oKkgCBqIyTc19QlYDwrV9/vh2HHS6nna3VlzSKQCTIyHIFZhsw24MDaYwsVvh8g8/3eM5is0LzDZrv0QqSdAXPoxkgK8NBsMeWHREsWmjTemf2AQ3zRMlKRCiUXCq/puoHQoliTKAiDt9mFy4n+HLygIl+BP77+/fvefOaEcNzZvE+rJSWyi8lCMPUcjRNsFO/N43qZc1UzGXjpxBFTMyIIiepXRTZpS+lBgNS+IpxaqBmMyTURIDLrWRr9bEUBjXs/hgXa7lz0BKcN64ozjtzJMS0AN75IFKmwMyk5ER0pYMu3Vr98JwoHWPgo+vM+FiR1LsWya3nzBimkC5pCCLxraNle47LihlprgRHuSXaojesNcgoKnQsVeGHtARDOdweNw1I0OkL4B41LMjBoPuRdSGlSQfvVBigHKhm0cxRNsGZ7WWtvZAMLVEKScqHY0+f9x62pIqJ5c5VSPBJvkPs9ffd8fX3iXGwjviiD4xq9jOQLdIpjWSzXt3DZv+nmOCivjU47wOpIqZ8XLYHLTlEhzHbgsoYKVCpoKCqQyNqyTwnI7g7nyWPJz5SNIJK++eyXRI8tsIgI7jxKm4qP5ZhpVENGgLODkcFZclZ30BkUt+zvs+sTl5NLEkeuKK+vSBRXbLQIEUNSB/PTGxjONUlKRxNz/QF9V7NjvX9HyhKqQx9PHmpr+xdfc4eGs1TMlY3jet3glV5LZruFX34lJwa5iPH+n4Y/jwc0KpzODGYd+/2q3sLKOg9E8qKa4Z0FRjODvb4bREIJCtzABGDADN86/8KFgE9/EiHCvcP939v/RhQn91T1xHVBAlPvrbk3x38tT+hiKr87def6WptXcmsJVkH2pIfV/wINA04i175nfeHAN2SgbiLmXNmBLd11kr88PKUOpT3Qj2lQoUuCWKRyPjjysPVuos5jy6Ga3NO4zNJeNfExQM+NVjEaiaM9oUUS71dVZo2BGetCJLsoOtkc8xQCqOoNghCKfRyTkVjK3CJHXM4WfPbL2U+cTntmEJSsGl5MxxOWka7J1libZ5kmD5jp9qZHz/Kk251ionMU9d90kyeoLmce8fO3MzzVSPhbEtgHwjTTF9zcoLjphU125nbuY7tFYVvKfwDZRzua06o12m0WK8yx9zOee4SDF6Z1u2TpaXUX9QCDYfp+/a10sZuEl5o+dW1z6t7jIzGOEttD4lSnxrrqnbmJ02i22sYdapuzqxgrPtrfXY7wNi1YE7uZ2vTTT5L+0fm2ld6bbK/jMHd+DsHBDd2/F7bO3OehuvQz124nJTXa1bx/gl2Eou7vhV6pOFwYeHWGpNNw4351tHDtqMeCicLhiQuwbr2BQg0TtvLqk5Cj+DWrWSnd+bWq7t2yiWJTQLc3lqb8vU25buGsz18Kt4Vo+4Ilvpd2vWkD7D1mJRcEtaGxgu21iY6vmzCr/Fsj5/CrylFTrQRjec9hC8NtOSVWRp6fia4hK5t8l4O8tJ0vnV01u10FOY782NZrCW7UQRLyQzL+ocUXUTDj0Ev/LyrhiUlimyaQp8Nn0GsaR1AlO7E2lp/NJPkeiGuck1YE3MnePxYmNTJrz/f/gclAIzAvw0AAA=="
const buttonStyles = "atm_gi_idpfg4 atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4 atm_kd_idpfg4 atm_2d_1nxixhv atm_7l_1638ien atm_9j_tlke0l atm_ks_15vqwwr atm_mk_h2mmj6 atm_cs_ni7l0g atm_bx_1kw7nm4 atm_g3_susbyh atm_fr_h89mgz atm_t9_1dk0nxm atm_cb_bys6i1 atm_r2_1j28jx2 atm_uc_13oqif8 atm_3f_1mvzw1k atm_5j_1y44olf atm_2f0cbj_1w8ultu atm_yo9tfo_kb7nvz atm_121i3vp_m5sa4a atm_ps9eqr_m5sa4a atm_1rzs1vq_1rp9mwy atm_1rauy5l_t1lyq2 atm_1s473yy_rwbglg atm_xvuojx_jyis0o atm_1yfe54e_1xvjxo1 atm_3hnrc7_bfngof atm_1vt4hf4_glywfm atm_9rhhw_1jxnbgj";
const elevationStyles = "atm_raf0b7_2fli30";
const cleanStyles = "atm_7l_13soded atm_2d_1j28jx2 atm_3f_okh77k atm_lo_1y44olf atm_le_1y44olf atm_lk_1fwxnve atm_ll_1fwxnve atm_cs_bfngof atm_tz4kk7_1i8phvx atm_1s473yy_17gc6ap";
const cancelStyles = "atm_2d_1v3w09r atm_7l_r3uz5 atm_1i1170i_13soded";
const borderStyles = "atm_3f_29a9wj";
const outlinedStyles = "atm_4b_1w2fqv2 atm_7l_p99jul";
const smallStyles = "atm_c8_wli6ec";
const mediumStyles = "atm_jb_1fwpi09 atm_c8_1x7uoys atm_lo_ftgil2 atm_le_ftgil2 atm_lk_1fwxnve atm_ll_1fwxnve";
const largeStyles = "atm_c8_1x7uoys atm_jb_1fwpi09 atm_vy_1osqo2v atm_lo_exct8b atm_le_exct8b";
const rippleStyles = "atm_mk_stnw88 atm_k4_1piyxwk atm_2d_1638ien atm_tr_1ooetej atm_mj_glywfm atm_5j_1ssbidh atm_1w_kb7nvz atm_r2_1j28jx2";
const allowOverflowStyles = "atm_ks_ewfl5b";
const getSizes = (size: ButtonSize) => {
  switch (size) {
    default:
    case 'small':
      return smallStyles;
    case 'medium':
      return mediumStyles;
    case 'large':
      return largeStyles;
  }
};
export type ButtonSize = 'small' | 'medium' | 'large';
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ref?: any;
  allowOverflow?: boolean;
  children?: any;
  size?: ButtonSize;
  clean?: boolean;
  border?: boolean;
  cancel?: boolean;
  disabled?: boolean;
  disableElevation?: boolean;
  outlined?: boolean;
}
const Button = (props: ButtonProps) => {
  const {
    ref,
    allowOverflow,
    children,
    className,
    size = 'small',
    border = false,
    clean = false,
    cancel = false,
    disableElevation = false,
    onClick,
    onTouchStart,
    outlined,
    ...rest
  } = props;
  const rippleRef = useRef<HTMLSpanElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  useImperativeHandle(ref, () => buttonRef.current);
  const sizeStyles = getSizes(size);
  const rippleClick = event => {
    animateRipple(event.clientX, event.clientY, rippleRef, buttonRef);
    onClick?.(event);
  };
  const rippleTouch = event => {
    if (onTouchStart) {
      animateRipple(event.touches[0].clientX, event.touches[0].clientY, rippleRef, buttonRef);
      onTouchStart(event);
    }
  };
  return <button ref={buttonRef} onClick={rippleClick} onTouchStart={rippleTouch} {...rest} className={cx('mfc-button', buttonStyles, !(disableElevation || clean || cancel) && elevationStyles, (clean || cancel) && cleanStyles, sizeStyles, cancel && cancelStyles, border && borderStyles, outlined && outlinedStyles, allowOverflow && allowOverflowStyles, className)}>
            {children}
            <span ref={rippleRef} className={cx('ripple', rippleStyles)}></span>
        </button>;
};
export default Button;